import React from 'react';
import ReactMarkdown from 'react-markdown';
import { FeedbackForm } from '../components/FeedbackForm';

const guideContent = `
# Welcome to findyourpeople.app! 🎉

Thank you for being an early tester. Here's what we need help testing:

## Key Areas to Test 🧪

1. **Application & Onboarding**
   - Submit your application and note the review notification behavior
   - Complete the preference questionnaire
   - Check if dealbreaker warnings appear when setting too many
   - Verify your profile completion score updates correctly
   - Test the navigation between steps

2. **Profile Management**
   - Update your personal information
   - Add/edit contact details
   - Enable two-factor authentication
   - Test notification preferences
   - Verify changes are saved correctly

3. **Matching System**
   - Review how dealbreakers affect your matches
   - Check if matches align with your preferences
   - Verify distance calculations for transit options
   - Test the premium upgrade flow
   - Confirm match notifications work

4. **Navigation & UI**
   - Test the responsive sidebar navigation
   - Verify mobile menu functionality
   - Check all page transitions
   - Test form validations
   - Verify loading states and animations

5. **Security Features**
   - Test two-factor authentication setup
   - Try email verification
   - Check remember me functionality
   - Test session management
   - Verify profile privacy settings

## Specific Test Cases 📝

1. **Dealbreaker Testing**
   - Try setting more than 2 absolute dealbreakers
   - Check if warnings appear appropriately
   - Verify impact on match results
   - Test dealbreaker flexibility options

2. **Notification Testing**
   - Verify application status notification shows for 2 seconds
   - Check if notifications fade out smoothly
   - Test different notification types
   - Verify notification positioning

3. **Premium Features**
   - Test upgrade flow
   - Verify match limit removal
   - Check premium-only features
   - Test payment processing

## How to Report Issues 🐛

Use the feedback form below to:
- Report any bugs or issues
- Suggest improvements
- Share your experience
- Rate specific features

Please be as detailed as possible when reporting issues:
1. What were you trying to do?
2. What actually happened?
3. What did you expect to happen?
4. Any error messages you saw?

## Questions? 💭

Contact us anytime at help@findyourpeople.app
`;

export function TesterGuide() {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <div className="prose prose-indigo max-w-none">
        <ReactMarkdown>{guideContent}</ReactMarkdown>
      </div>
      
      <div className="mt-12">
        <FeedbackForm />
      </div>
    </div>
  );
}